import alerts from "@/components/alerts/alert";
const confirmations = {
  confirmationSave(
    module,
    payload = [],
    title = "Apa kamu yakin ?",
    text = "",
    button = ""
  ) {
    alerts.questionConfirmation(payload, module, title, text, button);
  },
  confirmationUpdate(
    module,
    payload = [],
    title = "Apa kamu yakin ?",
    text = "Setelah submit data tidak dapat dikembalikan",
    button = ""
  ) {
    alerts.questionConfirmation(payload, module, title, text, button);
  },
  confirmationDelete(
    module,
    payload = [],
    title = "Apa kamu yakin ?",
    text = "You won't be able to revert this!",
    button = ", delete it!",
    icon = "warning"
  ) {
    alerts.questionConfirmation(payload, module, title, text, button, icon);
  },
  confirmationApprove(
    module,
    payload = [],
    title = "Apa kamu yakin ?",
    text = "Setelah submit data tidak dapat dikembalikan.",
    button = ""
  ) {
    alerts.questionConfirmation(payload, module, title, text, button);
  },
  confirmationReject(
    module,
    payload = [],
    title = "Apakah yakin ingin direject ?",
    text = "Setelah Reject data tidak dapat dikembalikan.",
    button = ", Reject it"
  ) {
    alerts.questionConfirmation(payload, module, title, text, button);
  },
  confirmationForm(
    payload = [],
    module,
    title = "Apa kamu yakin ?",
    text = "",
    button = ""
  ) {
    alerts.questionConfirmation(payload, module, title, text, button);
  },
};

export default confirmations;
